<template>
  <div class="wrapper">
    <!-- Modal Component -->
    <b-modal title="Información del contenido" class="modal-info" v-model="infoModal" @ok="toogleModal" ok-variant="info">
      <ul>
        <li><b>ID:</b> {{contentInfo.id}} </li>
        <li><b>TARJA:</b> {{contentInfo.number}} </li>
        <li><b>KILOS </b>NETOS: {{contentInfo.kilograms}} </li>
        <li><b>PRODUCTO:</b> {{contentInfo.product}} </li>
        <li><b>TIPO DE PRODUCTO:</b> {{contentInfo.product_type}} </li>
        <li><b>VARIEDAD:</b> {{contentInfo.variety}} </li>
        <li><b>CONDICION:</b> {{contentInfo.condition}} </li>
        <li><b>CANTIDAD:</b> {{contentInfo.quantity}} </li>
        <li><b>FORMATO:</b> {{contentInfo.container}} - <span  v-for="item in contentInfo.specs" :key="item.id">({{item.spec}})</span></li>
      </ul>
    </b-modal>
  </div>

</template>

<script>

export default {
  name: 'iModal',
  props: {
      infoModal: {
        type: Boolean,
        default: false
      },
      contentInfo: {
        type: Object,
        default: () => []
      }
  },
  data () {
    return {

    }
  },
  methods: {
      toogleModal(){
          this.infoModal = false
          this.$emit('closeModal', this.infoModal)
      }
  }
}
</script>